/* iconWrapper-compiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./iconWrapper-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { getTitleBoxHeight } from '../common';
export function titleBoxHeight(hasTitleBox, breakpoint) {
  // there is no titlebox
  if (!hasTitleBox) {
    return "0px";
  }

  // calculate height of the titlebox
  var marginBottom = getTitleBoxHeight(breakpoint);
  return "".concat(marginBottom, "px");
}
var iconWrapperStyles = null;
export var IconWrapper = function IconWrapper(props) {
  var breakpoint = props.breakpoint,
    hasTitleBox = props.hasTitleBox;
  return /*#__PURE__*/React.createElement("div", {
    id: "iconWrapper",
    style: {
      height: "calc(100% - ".concat(titleBoxHeight(hasTitleBox, breakpoint), ")")
    },
    className: ax(["_kqswstnw _1bsb1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"])
  }, props.children);
};
IconWrapper.displayName = 'MediaIconWrapper';